import React, { useContext, useEffect, useState } from "react";
import "../../../../../styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/AddExistingCustomerUser.css";
import {usersMicroserviceUrl} from "../../../../../microservices/users_microservice.js";
import { thingsBoardMicroserviceUrl } from "../../../../../microservices/thingsboard_microservice.js";
import { CustomerContext } from "../CustomerProvider.jsx";
import { AppContext } from "../../../../AppProvider.jsx";
const AddExistingCustomerUser = ({showAddExistingCustomerUserWindow,setShowAddExistingCustomerUserWindow,customer}) =>{
    const {user,logout} = useContext(AppContext);
    const {selectedTenantAdminProfile} = useContext(CustomerContext);
    const [customerUserNamesFetched,setCustomerUserNamesFetched] = useState(false);
    const [customerUserNameFilterString,setCustomerUserNameFilterString] = useState('');
    const [showCustomerUserNamesBrowser,setShowCustomerUserNamesBrowser] = useState(false);
    const [customerUserRole,setCustomerUserRole] = useState('select');
    const [customerUserNames,setCustomerUserNames] = useState(null);
    const [selectedCustomerUserName,setSelectedCustomerUserName] = useState(null);
    const [customerUser,setCustomerUser] = useState(null);
    const [addingCustomerUserStatus,setAddingCustomerUserStatus] = useState('');
    const fetchAllCustomerUserNames = async() =>{
        try{
            const url = `${usersMicroserviceUrl}/tenants/customers/all/get`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok) setCustomerUserNames(await response.json());
        }
        catch(error){
            console.error(error);
        }
    };
    const fetchCustomerUser = async() => {
        try{
            const url = `${usersMicroserviceUrl}/tenants/customers/get?username=${selectedCustomerUserName}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            const responseData = await response.json();
            setCustomerUser(responseData);
        }
        catch(error){
            console.error(error);
        }
    };
    const registerCustomer = async() =>{
        try{
            setAddingCustomerUserStatus('adding');
            const customerUserModel = {
                username:customerUser.emailAddress,
                customerId:customer?.local?.id,
                role:customerUserRole
            };
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/customers/users`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                },
                body:JSON.stringify(customerUserModel)
            });
            if(response.ok){
                setAddingCustomerUserStatus('added');
                return;
            }
        }
        catch(error){
            console.error(error);
            setAddingCustomerUserStatus('error');
        }
    };
    const disposeWindow = () =>{
        setAddingCustomerUserStatus('');
        setShowAddExistingCustomerUserWindow(false);
    };
    useEffect(() =>{
        if(customerUserNamesFetched) return;
        async function fetchCustomerUserNames(params) {
            await fetchAllCustomerUserNames();
        }
        fetchCustomerUserNames();
        setCustomerUserNamesFetched(true);
    },[customerUserNamesFetched]);
    useEffect(() =>{
        if(!showAddExistingCustomerUserWindow) {
            setCustomerUserNamesFetched(false);
            setCustomerUser(null);
            setSelectedCustomerUserName(null);
            setCustomerUserNameFilterString('');
        }
    },[showAddExistingCustomerUserWindow]);
    useEffect(() =>{
        if(!showAddExistingCustomerUserWindow) return;
        async function getCustomerUser() {
            await fetchCustomerUser();
        }
        if(selectedCustomerUserName) getCustomerUser();
        else setCustomerUser(null);
    },[selectedCustomerUserName]);
    if(!showAddExistingCustomerUserWindow) return null;
    return(
        <div className="tenant-administrator-add-existing-customer-user-parent-container">
            {addingCustomerUserStatus === ''?
                (
                    <div className="tenant-administrator-add-existing-customer-user-container">
                        <div className="tenant-administrator-add-existing-customer-user-header">
                            <h1>Add exising user</h1>
                            <p onClick={() => disposeWindow()}>&#10006;</p>
                        </div>
                        <div className="tenant-administrator-add-existing-customer-user-body">
                            <div className="tenant-administrator-add-existing-customer-user-details-entry-container unpadded">
                                <p className="title-p">Select existing user to add</p>
                                {selectedCustomerUserName?
                                    (
                                        <div className="tenant-administrator-add-existing-customer-user-selected-customer-user-name-display">
                                            <p>{selectedCustomerUserName}</p>
                                            <p className="close-p" title="Remove selection" onClick={() => setSelectedCustomerUserName(null)}>&#10006;</p>
                                        </div>
                                    ):
                                    (
                                        <input
                                            placeholder="Enter user email address to filter"
                                            value={customerUserNameFilterString}
                                            onChange={(e) => setCustomerUserNameFilterString(e.target.value)}
                                            onFocus={() => setShowCustomerUserNamesBrowser(true)}
                                            onBlur={() =>{
                                                setTimeout(() => setShowCustomerUserNamesBrowser(false),150);
                                            }}
                                        />
                                    )
                                }
                                <div className={`tenant-administrator-add-existing-customer-user-customer-users-browser ${showCustomerUserNamesBrowser? 'active':''}`}>
                                    {customerUserNames && [...customerUserNames].filter((selectedCustomerUserName) => selectedCustomerUserName?.toLowerCase()?.includes(customerUserNameFilterString.toLocaleLowerCase()))
                                    .sort((a,b) => a?.toLowerCase().localeCompare(b?.toLowerCase())).map((selectedCustomerUserName) =>(
                                        <div key={selectedCustomerUserName} onClick={() =>{
                                            setCustomerUserNameFilterString('');
                                            setSelectedCustomerUserName(selectedCustomerUserName);
                                        }}>
                                            <p>{selectedCustomerUserName}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="tenant-administrator-add-existing-customer-user-details-entry-container">
                                <p className="title-p">First name</p>
                                <p>{customerUser?.firstName || 'Unavailable'}</p>
                            </div>
                            <div className="tenant-administrator-add-existing-customer-user-details-entry-container">
                                <p className="title-p">Last name</p>
                                <p>{customerUser && customerUser.lastName? customerUser.lastName:'Unavailable'}</p>
                            </div>
                            <div className="tenant-administrator-add-existing-customer-user-details-entry-container">
                                <p className="title-p">Email address</p>
                                <p>{customerUser && customerUser.emailAddress? customerUser.emailAddress:'Unavailable'}</p>
                            </div>
                            <div className="tenant-administrator-add-existing-customer-user-details-entry-container">
                                <p className="title-p">Role<span>*</span></p>
                                <select
                                    name="role"
                                    value={customerUserRole}
                                    onChange={(e) => setCustomerUserRole(e.target.value)}
                                >
                                    <option value="select" disabled>Select role</option>
                                    <option value="ADMIN">Administrator</option>
                                    <option value="USER">User</option>
                                </select>
                            </div>
                            <div className="tenant-administrator-add-existing-customer-user-buttons-container">
                                <button className="cancel" onClick={() => {
                                    setCustomerUserRole('select');
                                    setShowAddExistingCustomerUserWindow(false);
                                }}>Cancel</button>
                                <button className="add active" onClick={async() =>{
                                    if(!customerUser){
                                        window.alert('Select the existing user you wish to add');
                                        return;
                                    }
                                    else if(customerUserRole === 'select'){
                                        window.alert('Select the intended role of the added user');
                                        return;
                                    }
                                    await registerCustomer();
                                }}>Add</button>
                            </div>
                        </div>
                    </div>
                ):addingCustomerUserStatus === 'adding'?
                (
                    <div className="tenant-administrator-adding-existing-customer-user-container">
                        <div>
                        </div>
                        <p>Adding customer user. Please wait...</p>
                    </div>
                ):
                (
                    <div className="tenant-administrator-added-existing-customer-user-container">
                        <p>Customer user added successfully</p>
                        <div>
                            <button onClick={() => disposeWindow()}>Okay</button>
                        </div>
                    </div>
                )
            }
        </div>
    );
};
export default AddExistingCustomerUser;